import { useState } from 'react';

import { Button, Drawer, Text } from 'shell/components';

const DrawerDemo = () => {
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);

    return (
        <>
            <Text variant={'sh1'}>Drawer</Text>
            <Button onClick={() => setOpen1(true)}>Open Left Drawer</Button>
            <Button onClick={() => setOpen2(true)}>Open Right Drawer</Button>
            <Drawer anchor={'left'} open={open1} onClose={() => setOpen1(false)}>
                <Text variant={'sh1'}>Drawer Content</Text>
            </Drawer>
            <Drawer open={open2} onClose={() => setOpen2(false)}>
                <Text variant={'sh1'}>Drawer Content</Text>
            </Drawer>
        </>
    );
};

export default DrawerDemo;
